module.exports = __webpack_public_path__ + "a53a7803ea2284c12ceb7671c43c8514.pdf";